import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface BranchMismatchLeadCardState {
  isSelectionMode: boolean;
  selectedLeadIds: (string | number)[];
  /** True when "Select All" has selected EVERY matching lead across pages
   *  (not just the current page). Drives the toolbar count to show total
   *  rather than current-page-selected. */
  isAllAcrossPagesSelected: boolean;
  searchTerm: string;
  currentPage: number;
}

const initialState: BranchMismatchLeadCardState = {
  isSelectionMode: false,
  selectedLeadIds: [],
  isAllAcrossPagesSelected: false,
  searchTerm: "",
  currentPage: 1,
};

const branchMismatchLeadCardSlice = createSlice({
  name: "branchMismatchLeadCard",
  initialState,
  reducers: {
    setIsSelectionMode: (state, action: PayloadAction<boolean>) => {
      state.isSelectionMode = action.payload;
    },
    toggleLeadSelection: (state, action: PayloadAction<string | number>) => {
      const id = action.payload;
      if (state.selectedLeadIds.includes(id)) {
        state.selectedLeadIds = state.selectedLeadIds.filter((x) => x !== id);
      } else {
        state.selectedLeadIds.push(id);
      }
      // Touching a single row breaks the "all across pages" assertion.
      state.isAllAcrossPagesSelected = false;
    },
    clearSelectedLeadIds: (state) => {
      state.selectedLeadIds = [];
      state.isAllAcrossPagesSelected = false;
    },
    selectAllLeads: (state, action: PayloadAction<(string | number)[]>) => {
      state.selectedLeadIds = action.payload;
      // Caller is selecting current page only — clear the across-pages flag.
      state.isAllAcrossPagesSelected = false;
    },
    selectAllAcrossPages: (
      state,
      action: PayloadAction<(string | number)[]>
    ) => {
      state.selectedLeadIds = action.payload;
      state.isAllAcrossPagesSelected = true;
    },
    setBranchMismatchSearchTerm: (state, action: PayloadAction<string>) => {
      state.searchTerm = action.payload;
      state.currentPage = 1;
    },
    setBranchMismatchCurrentPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload;
    },
    resetBranchMismatchPanel: (state) => {
      state.isSelectionMode = false;
      state.selectedLeadIds = [];
      state.isAllAcrossPagesSelected = false;
      state.searchTerm = "";
      state.currentPage = 1;
    },
  },
});

export const {
  setIsSelectionMode,
  toggleLeadSelection,
  clearSelectedLeadIds,
  selectAllLeads,
  selectAllAcrossPages,
  setBranchMismatchSearchTerm,
  setBranchMismatchCurrentPage,
  resetBranchMismatchPanel,
} = branchMismatchLeadCardSlice.actions;
export default branchMismatchLeadCardSlice.reducer;
